import { useAuth0 } from '@auth0/auth0-react';
import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import configuration from '../../configuration';

interface BeginPollingRequest {
    pollId: number;
}

export function useBeginPolling(
    options?: Omit<
        UseMutationOptions<
            void,
            AxiosError,
            BeginPollingRequest
        >,
        'mutationKey' | 'mutationFn'
    >,
) {
    const { getAccessTokenSilently } = useAuth0();
    return useMutation(
        async (req: BeginPollingRequest) => {            
            const token = await getAccessTokenSilently();
            axios.post(`${configuration.apiUrl}/polls/polls/${req.pollId}/start`, null, {
                headers: {
                    'authorization': `bearer ${token}`
                }
            });

        }, options
    );
}